$(readyFunction);

function readyFunction() {
    var windowWidth;
    var attached;
    var navigationBlock = $('#sticky_nav');

    widthCheck();

    $(window).on('resize', function () {
        setTimeout(function () {
            widthCheck();
        }, 100);
    });

    function widthCheck() {
        windowWidth = $(window).width();
        if (windowWidth < 992) {
            if (attached !== false) {
                if (navigationBlock) {
                    navigationBlock.trigger('sticky_kit:detach');
                }

                $('.context-navigation_expand')
                    .addClass('fa-plus')
                    .removeClass('fa-times')
                    .parents('.context-navigation__list-wrapper')
                    .find('ul').hide();
            }
            attached = false;
        } else {
            if (attached !== true) {
                if (navigationBlock) {
                    make_sticky();
                }

                $('.context-navigation_expand')
                    .addClass('fa-times')
                    .removeClass('fa-plus')
                    .parents('.context-navigation__list-wrapper')
                    .find('ul').show();
            }
            attached = true;
        }
    }

    function make_sticky() {
        navigationBlock.stick_in_parent({
            //parent: '.container',
            offset_top: 68
        });
    }

    $('.context-navigation_expand').on('click', function (e) {
        var element = $(this);
        e.preventDefault();
        e.stopPropagation();
        if (element.hasClass('fa-plus')) {
            element
                .addClass('fa-times')
                .removeClass('fa-plus')
                .parents('.context-navigation__list-wrapper')
                .find('ul')
                .show();
        } else {
            element
                .addClass('fa-plus')
                .removeClass('fa-times')
                .parents('.context-navigation__list-wrapper')
                .find('ul')
                .hide();
        }
    })
}